import { getIn } from 'formik';
import { FormikAutocomplete } from '../../../input/FormikAutocomplete/FormikAutocomplete';
import { TemplateFormFieldProps } from '../../interfaces/template-form';
import { TemplateFormDropdownFieldMetaProps } from './interfaces/template-form-dropdown-field-meta';
import { TextFieldProps } from '../../../input/TextField/TextField';

export function TemplateFormDropdownField({
  metadata,
  field,
  form,
  meta,
  formDisabled
}: TemplateFormFieldProps) {
  const { disabled, textFieldProps, ...rest } = metadata as TemplateFormDropdownFieldMetaProps;
  const showError =
    (form.touched[field.name] && !!form.errors[field.name]) ||
    (getIn(form.errors, field.name) && getIn(form.touched, field.name));

  return (
    <FormikAutocomplete
      {...rest}
      textFieldProps={{
        ...(textFieldProps as TextFieldProps),
        error: showError
      }}
      onBlur={async () => {
        await form.setFieldTouched(field.name, true);
      }}
      disabled={disabled || formDisabled}
      field={field}
      form={form}
      meta={meta}
    />
  );
}
